(function() {
  var style = document.createElement('style');
  style.textContent = `
    body:not(.template-product) .grid-product__price {
      color: #e00000 !important;
      font-size: 15px !important;
      display: flex;
      flex-direction: row-reverse;
      gap: 8px;
      align-items: center;
      font-weight: 400 !important;
      font-family: Montserrat, sans-serif !important;
      letter-spacing: 0.02em !important;
      line-height: 1.4 !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    
    .template-product .grid-product__price {
      font-weight: bold !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    
    .grid-product__price--original {
      color: #999 !important;
      text-decoration: line-through;
      opacity: 0.8;
      order: 2;
      font-size: 14px !important;
      font-weight: 400 !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    
    .grid-product__price--savings {
      order: 3;
      margin-left: auto;
      color: #666 !important;
      font-size: 13px !important;
      font-weight: 400 !important;
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      margin-right: 0 !important;
      padding: 0 !important;
    }
    
    .visually-hidden {
      display: none;
      margin: 0 !important;
      padding: 0 !important;
    }
    
    .price--on-sale .price-item--sale {
      color: #e00000 !important;
      font-weight: bold !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    
    .price--on-sale .price-item--regular {
      color: #999 !important;
      text-decoration: line-through;
      font-weight: 400 !important;
      margin: 0 !important;
      padding: 0 !important;
    }
  `;
  document.head.appendChild(style);
})();